import { call } from 'redux-saga/effects';

let initModule = null;
export function* initPurchaseMiMovistarNoClient({ payload }) {
  if (!initModule) {
    initModule = yield call(() => import('./init'));
  }
  // llamada a modulo
  yield call(initModule.initPurchaseMiMovistarNoClient, { payload });
}
let setInfoModule = null;
export function* setInfoMiMovistarNoClient({ payload }) {
  if (!setInfoModule) {
    setInfoModule = yield call(() => import('./set-info'));
  }
  // llamada a modulo
  yield call(setInfoModule.setInfoMiMovistarNoClient, { payload });
}
let checkOutModule = null;
export function* checkoutMiMovistarNoClient({ payload }) {
  if (!checkOutModule) {
    checkOutModule = yield call(() => import('./checkout'));
  }
  // llamada a modulo
  yield call(checkOutModule.checkoutMiMovistarNoClient, { payload });
}
let processOrderModule = null;
export function* processOrderMiMovistarNoClient() {
  if (!processOrderModule) {
    processOrderModule = yield call(() => import('./process-order'));
  }
  // llamada a modulo
  yield call(processOrderModule.processOrderMiMovistarNoClient, {});
}
let sendPurchaseOtpModule = null;
export function* sendPurchaseOtpMiMovistarNoClient({ payload }) {
  if (!sendPurchaseOtpModule) {
    sendPurchaseOtpModule = yield call(() => import('./send-purchase-otp'));
  }
  // llamada a modulo
  yield call(sendPurchaseOtpModule.sendPurchaseOtpMiMovistarNoClient, {
    payload,
  });
}
let sendPortabilityOtpModule = null;
export function* sendPortabilityOtpMiMovistarNoClient({ payload }) {
  if (!sendPortabilityOtpModule) {
    sendPortabilityOtpModule = yield call(() =>
      import('./send-portability-otp')
    );
  }
  // llamada a modulo
  yield call(sendPortabilityOtpModule.sendPortabilityOtpMiMovistarNoClient, {
    payload,
  });
}
let validatePurchaseOtpModule = null;
export function* validatePurchaseOtpMiMovistarNoClient({ payload }) {
  if (!validatePurchaseOtpModule) {
    validatePurchaseOtpModule = yield call(() =>
      import('./validate-purchase-otp')
    );
  }
  // llamada a modulo
  yield call(validatePurchaseOtpModule.validatePurchaseOtpMiMovistarNoClient, {
    payload,
  });
}
let validatePortabilityOtpModule = null;
export function* validatePortabilityOtpMiMovistarNoClient({ payload }) {
  if (!validatePortabilityOtpModule) {
    validatePortabilityOtpModule = yield call(() =>
      import('./validate-portability-otp')
    );
  }
  // llamada a modulo
  yield call(
    validatePortabilityOtpModule.validatePortabilityOtpMiMovistarNoClient,
    {
      payload,
    }
  );
}
let validateAllOtpsModule = null;
export function* validateAllOtpsMiMovistarNoClient({ payload }) {
  if (!validateAllOtpsModule) {
    validateAllOtpsModule = yield call(() => import('./validate-all-otps'));
  }
  yield call(validateAllOtpsModule.validateAllOtpsMiMovistarNoClient, {
    payload,
  });
}
